import React from "react"

const ViewCounter = ({ slug }) => {
  const [views, setViews] = React.useState(undefined)

  React.useEffect(() => {
    async function fetchViews() {
      const res = await fetch(
        `https://workers-supabase-hit-counter.anr-1920.workers.dev?slug=${slug}`
      )
      const resJSON = await res.json()
      if (typeof resJSON.views === "number") {
        setViews(resJSON.views)
      }
    }
    if (process.env.NODE_ENV === "production") {
      fetchViews()
    }
  }, [slug])
  return <>Views : {typeof views === "number" ? views : "loading..."}</>
}

export default ViewCounter
